import { Component, OnInit } from '@angular/core';
import { BaseTabsUpdateComponent, TabsContainerService, BaseDataService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { KursDokument } from './kurs-dokument';

@Component({
  selector: 'yt-kurs-dokument-tab-update',
  templateUrl: './kurs-dokument-tab-update.component.html'
})
export class KursDokumentTabUpdateComponent extends BaseTabsUpdateComponent<KursDokument> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<KursDokument>,
    protected baseDataService: BaseDataService,
    protected userService: UserService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
